import React from 'react';

const AgentsPhonePage = () => {
  return (
    <div>
      <h1>Phone Page</h1>
    </div>
  );
};

export { AgentsPhonePage }; 